export const initialUplinkFieldsState = {
    uplink: false,
    reason: null,
    urgency: null,
    expandOptions: false,
};
export const useUplinkArgs = (fields, updateFields) => {
    const { uplink, reason, urgency, expandOptions } = fields;
    const handleUplinkUrgencyClick = (newUrgency) => {
        updateFields({ ...fields, urgency: urgency === newUrgency ? null : newUrgency });
    };
    const handleUplinkReasonClick = (newReason) => {
        updateFields({ ...fields, reason: reason === newReason ? null : newReason });
    };
    const toggleUplink = () => {
        updateFields({ ...fields, uplink: !uplink });
    };
    const toggleExpandOptions = () => {
        updateFields({ ...fields, expandOptions: !expandOptions });
    };
    let commandArg = `${uplink ? "/U" : ""}${reason ?? ""}${urgency ?? ""}`;
    if (commandArg.length > 0) {
        commandArg += " ";
    }
    return {
        uplink,
        toggleUplink,
        reason,
        urgency,
        handleUplinkUrgencyClick,
        handleUplinkReasonClick,
        expandOptions,
        toggleExpandOptions,
        commandArg,
    };
};
//# sourceMappingURL=useUplinkArgs.js.map